import React, { forwardRef, memo } from 'react';
import cn from 'classnames';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  type = 'button',
  ...props
}, ref) => (
  <button
    className={cn('btn', className)}
    ref={ref}
    // eslint-disable-next-line react/button-has-type
    type={type}
    {...props}
  />
));

export default memo(Button);
